<ul *ngIf="data && data.length > 0">
  <li *ngFor="let item of data">
    <div class="d-flex align-items-center">
      <span class="toggle-icon" *ngIf="item.children" (click)="toggleFolder(item)">
        <i [ngClass]="{ 'ti-chevron-right': item.expanded, 'ti-chevron-down': !item.expanded }"></i>
      </span>
      <span
        [ngClass]="{
          'folder': item.type === 'folder',
          'file': item.type === 'file',
          'selectable': item.type === 'file',
          'selected-file': item.isSelected
        }"
        (click)="item.type === 'file' ? handleItemClick(item) : null"
      >
        {{ item.label }}
      </span>
    </div>
    <app-document-folder-tree *ngIf="item.children && item.expanded" [data]="item.children"></app-document-folder-tree>
  </li>
</ul>
